<template>
  <div class="container">
    <container :active_path="path"
               :plate="'云招商'">
      <div class="base-warp">
        <div class="head">
          <el-form :model="search"
                   ref="form"
                   label-width="80px"
                   :inline="true"
                   size="normal">
            <el-form-item label="类型">
              <el-select v-model="search.type"
                         placeholder="类型"
                         size="mini">
                <el-option :label="item"
                           :value="item"
                           v-for="(item, index) in types"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域">
              <el-select v-model="search.region"
                         placeholder="区域"
                         size="mini">
                <el-option :label="item.name"
                           :value="item.name"
                           v-for="(item, index) in regions"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="价格">
              <el-select v-model="search.price"
                         placeholder="价格"
                         size="mini">
                <el-option :label="item"
                           :value="item"
                           v-for="(item, index) in prices"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="search.status"
                         placeholder="状态"
                         size="mini">
                <el-option :label="item.label"
                           :value="item.value"
                           v-for="(item, index) in status"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model="search.keyword"
                        size="mini"
                        placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         size="mini"
                         @click="confirm">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-box">
          <el-table :data="tabledata"
                    border
                    stripe
                    @row-click="getrow"
                    size="small"
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
            <el-table-column label="序号"
                             type="index"
                             width="60"></el-table-column>
            <el-table-column label="项目名"
                             prop="name"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="用户"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.user.name}}/{{scope.row.user.telephone}}
              </template>
            </el-table-column>
            <el-table-column label="类型"
                             prop="type">
              <template slot-scope="scope">
                {{scope.row.type}}/{{scope.row.message?scope.row.message.mold:''}}
              </template>
            </el-table-column>
            <el-table-column label="地址"
                             width="200"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.location?scope.row.location.address:''}}
              </template>
            </el-table-column>
            <el-table-column label="价格">
              <template slot-scope="scope">
                {{scope.row.message?scope.row.message.price+'元/㎡/月':''}}
              </template>
            </el-table-column>
            <el-table-column label="面积">
              <template slot-scope="scope">
                {{scope.row.message?scope.row.message.area+'㎡':''}}
              </template>
            </el-table-column>
            <el-table-column label="中介费">
              <template slot-scope="scope">
                {{scope.row.message?scope.row.message.agency:''}}
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <p class="status text-warning"
                   v-if="scope.row.status=='02'">待审核</p>
                <p class="status text-success"
                   v-if="scope.row.status=='03'">已通过</p>
                <p class="status text-danger"
                   v-if="scope.row.status=='04'">不通过</p>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <el-pagination class="page-tion"
                       @current-change="currentChange"
                       layout="prev, pager, next"
                       :page-size="pagesize"
                       :total="total"
                       background>
        </el-pagination>
      </div>
    </container>
    <router-view></router-view>
  </div>
</template>

<script>
import container from "../../../components/container"
import baseRegion from '../../../units/region';
export default {
  components: {
    container,
  },
  data () {
    return {
      path: '/attract/project',
      search: {
        type: '',
        region: '',
        price: '',
        keyword: '',
        status: '',
      },
      pageNo: 1,
      pagesize: 14,
      types: ['全部', '商铺', '写字楼', '工业园', '厂房', '其他'],
      prices: ['价格不限', '20/㎡以下', '20-40/㎡', '40-60/㎡', '60-80/㎡', '80-100/㎡', '100/㎡以上'],
      status: [
        {
          label: '全部',
        },
        {
          label: '待审核',
          value: '02',
        },
        {
          label: '已通过',
          value: '03',
        },
        {
          label: '不通过',
          value: '04',
        },
      ],
      regions: [],
      tabledata: [],
      total: 0,
    }
  },
  mounted () {
    var regions = JSON.parse(JSON.stringify(baseRegion.wuhan))
    regions.unshift({ name: '不限' });
    this.regions = regions;
    this.getproject();
  },
  methods: {
    getrow (row) {
      console.log('2');
      console.log(row, 'row');
      var id = row._id['$oid'];
      this.$router.push({ path: '/attract/project/detail', query: { id } });
    },
    confirm () {
      this.pageNo = 1;
      this.getproject();
    },
    currentChange (page) {
      this.pageNo = page;
      this.getproject();
    },
    getproject () {
      var params = {
        pageNo: this.pageNo,
        pagesize: this.pagesize,
        region: this.search.region || '',
        price: this.search.price || '',
        keyword: this.search.keyword || '',
        type: this.search.type || '',
        status: this.search.status || '',
      }
      this.$api.getproject(params).then(
        data => {
          let { list, total } = data;
          for (var item of list) {
            if (item.message) item.message = JSON.parse(item.message)
            if (item.location) item.location = JSON.parse(item.location)
          }
          this.tabledata = list;
          this.total = total;
        }
      )
    },
  },
  beforeRouteUpdate (to, from, next) {
    if (from.path == "/attract/project/detail") {
      this.getproject();
    }
    next();
  },
}
</script>

<style lang="scss" scoped>
</style>